<template>
  <v-dialog v-model="show"
            fullscreen
            hide-overlay
            persistent>
    <v-toolbar light
               :class="'dialogFullToolBar'"
               color="default">
      <v-toolbar-items>
        <v-btn light
               flat
               @click="close">退出</v-btn>
      </v-toolbar-items>
      <v-toolbar-title>
        <!-- <img class="img" src="@/assets/dialog_logo.svg"> -->
        {{title}}
      </v-toolbar-title>
      <div class="timer">
        <img class="pr-1"
             src="@/assets/icon_timer.png"
             style="vertical-align:text-top">{{timer}}秒後自動登出</div>
      <v-toolbar-items>
        <v-btn light
               v-if="tempSaveBtn"
               flat
               class="btn-save"
               @click="save"
               :loading="loading"
               :class="loading?'lock':''">暫存</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div class="dialog-container"
         :style="customStyle">
      <div class="dialog-main">
        <div ref="topTarget"></div>
        <slot></slot>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'base-dialog-full',

  props: {
    tempSaveBtn: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loader: null,
      loading: false
    }
  },
  watch: {
    show (v) {
      if (!v) {
        this.scrollTop()
      }
    },
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    }
  },
  computed: {
    ...mapState({
      timer: 'timer'
    })
  },
  methods: {
    scrollTop (scrollIntoViewOptions) {
      const options = { ...{ block: 'end' }, ...scrollIntoViewOptions }
      this.$refs['topTarget'].scrollIntoView(options)
    },
    close () {
      this.$emit('close')
    },
    save () {
      this.$emit('save')
    }
  }
}
</script>
<style lang="stylus" scoped>
.img {
  vertical-align: sub;
  margin-right: 10px;
}
.dialogFullToolBar {
  user-select: none;
}
</style>
